import { render, staticRenderFns } from "./WorkflowChuanYue.vue?vue&type=template&id=81b20df2&scoped=true"
import script from "./WorkflowChuanYue.vue?vue&type=script&lang=js"
export * from "./WorkflowChuanYue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b20df2",
  null
  
)

export default component.exports